import React from 'react'
import { InputContainer } from '../../../../common/components/form/form.module';
import { currency } from '../../../../common/services/common.service';

export default function ModalEstimateComponent({ selectedEstimateItem, selectedVehicleItem,
    handleEstimateBack, dropLocations, pickupLocations, handleEstimateSubmit, productTypeCargo, handleInnerFormChange }: any) {

    return (

        <div className="w-full  bg-white">
            <h1 className="text-lg font-normal text-center">Get an Estimate</h1>


            <div className="grid grid-cols-1 gap-4">


                <div className="p-4">
                    <div className="appliance-card border-b border-gray-300 bg-white items-center justify-center overflow-hidden mb-6">
                        <h3 className="appliance-name flex items-center justify-center p-3 text-lg text-gray-900">{selectedVehicleItem?.VehicleType}</h3>

                        {/* Centered SVG */}
                        <div className="flex items-center justify-center max-w-full h-36">
                            {selectedVehicleItem?.vehicleImageUrl ? <img src={selectedVehicleItem?.vehicleImageUrl} className="w-36 h-36 " /> :
                                <svg fill="#000000" height="155px" width="155px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M106.846,320c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2s51.2-22.963,51.2-51.2 C158.046,342.963,135.074,320,106.846,320z M106.846,405.333c-18.825,0-34.133-15.309-34.133-34.133s15.309-34.133,34.133-34.133 s34.133,15.309,34.133,34.133S125.662,405.333,106.846,405.333z"></path> </g> </g> <g> <g> <path d="M396.919,320c-28.237,0-51.2,22.963-51.2,51.2c0,28.237,22.963,51.2,51.2,51.2c28.237,0,51.2-22.963,51.2-51.2 C448.12,342.963,425.148,320,396.919,320z M396.919,405.333c-18.825,0-34.133-15.309-34.133-34.133s15.309-34.133,34.133-34.133 s34.133,15.309,34.133,34.133S415.735,405.333,396.919,405.333z"></path> </g> </g> <g> <g> <path d="M503.467,294.4h-8.533V98.133c0-4.71-3.823-8.533-8.533-8.533H221.867c-18.85,0-34.133,15.283-34.133,34.133v179.2 h-17.067v-128c0-4.71-3.823-8.533-8.533-8.533h-102.4c-2.85,0-5.521,1.425-7.1,3.797l-51.2,76.8 C0.495,248.405,0,250.052,0,251.733V345.6c0,4.71,3.823,8.533,8.533,8.533h25.378c3.627,0,7.023-2.15,8.226-5.572 c9.583-27.281,35.49-45.628,64.427-45.628c17.775,0,39.134,6.4,49.911,14.933c1.638,1.297,3.567,2.133,5.658,2.133h25.6v25.6 c0,4.71,3.823,8.533,8.533,8.533h128c3.627,0,7.023-2.15,8.226-5.572c9.583-27.281,35.49-45.628,64.427-45.628 c28.732,0,54.485,18.099,64.23,45.082c1.041,3.533,4.309,6.118,8.183,6.118h34.133c4.71,0,8.533-3.823,8.533-8.533v-42.667 C512,298.223,508.177,294.4,503.467,294.4z M119.467,238.933c0,2.355-1.911,4.267-4.267,4.267H32.452 c-3.405,0-5.444-3.797-3.55-6.63l34.133-51.2c0.785-1.186,2.125-1.903,3.55-1.903H115.2c2.355,0,4.267,1.911,4.267,4.267V238.933z "></path> </g> </g> </g></svg>}
                        </div>

                        <div className="p-2">
                            <p className="text-sm text-gray-600 flex justify-center">Vehicle Weight: {selectedVehicleItem?.VehicleWeight}</p>
                            <p className="text-sm text-gray-600 flex justify-center">Capacity: Upto {selectedVehicleItem?.LoadingCapacity}Kg</p>
                        </div>

                        <div className="p-2">
                            <p className="text-xl  text-primary font-medium flex justify-center">{currency(selectedVehicleItem?.Price)}</p>
                        </div>

                    </div>
                    <div>
                        <InputContainer
                            labelField="Name"
                            list={productTypeCargo}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CategoryId'
                                );
                            }}
                            optionName='Product Type'
                            type="select"
                            value={selectedEstimateItem?.CategoryId}
                            valueField="Id"
                        />
                    </div>
                </div>

                {/* Right Section */}
                <div className="p-4 border-t border-gray-300">
                    <div className="bg-white">

                        <div className="items-center py-2">
                            <div className="font-semibold text-sm">PickUp Address</div>
                            <div className='text-xs'>{pickupLocations?.description}</div>
                        </div>

                        <div className="items-center py-2">
                            <div className="font-semibold text-sm">Drop Address</div>
                            <div className='text-xs'>{dropLocations?.description}</div>
                        </div>

                        <div className="items-center py-2">
                            <div className="font-semibold text-sm">Name</div>
                            <div className='text-xs'>{selectedEstimateItem?.Name}</div>
                        </div>

                        <div className="items-center py-2">
                            <div className="font-semibold text-sm">Phone Number</div>
                            <div className='text-xs'>{selectedEstimateItem?.PhoneNumber}</div>
                        </div>

                        {/* Edit Button */}
                        <div className="text-center mt-4">
                            <div className="flex justify-center gap-4">
                                {/* <button
                                    onClick={handleEstimateBack}
                                    type="button"
                                    className="bg-blue-700 text-white font-medium px-6 py-2 rounded">
                                    Back
                                </button> */}
                                <button
                                    onClick={handleEstimateSubmit}
                                    type="button"
                                    className="bg-primary text-light font-medium px-6 py-2 rounded">
                                    Get an Estimate
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>




    )
}